import PropTypes from 'prop-types'

import BusyOverlay from 'components/common/BusyOverlay'
import Text from 'components/common/Text'
import CardWrapper from 'components/dashboard/CardWrapper'
import Icon from 'components/Icon'
import useCompanyReportData from 'hooks/use-company-report-data'
import theme from 'theme'

function StatTile({ attackedHosts, attackedHostsLastMonth }) {
  const didHostAttackedIncrease = attackedHosts > attackedHostsLastMonth

  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        flexDirection: 'column'
      }}
    >
      <Text as="h1" color="medium">
        {attackedHosts}
      </Text>
      <Text
        as="h6"
        css={{
          textTransform: 'uppercase',
          fontSize: theme.fontSizes[1],
          fontWeight: theme.fontWeights[1]
        }}
      >
        Targets Experimented On
      </Text>
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        }}
      >
        {didHostAttackedIncrease ? (
          <Icon
            css={{ color: theme.colors.green[0], fontSize: theme.fontSizes[3] }}
            icon="trendingUp"
          />
        ) : (
          <Icon
            css={{ color: theme.colors.red[0], fontSize: theme.fontSizes[3] }}
            icon="trendingDown"
          />
        )}

        <Text
          as="small"
          css={{
            marginLeft: theme.space[2],
            color: theme.colors.steel[1],
            fontWeight: theme.fontWeights[1]
          }}
        >
          Last Month:
        </Text>
        <Text
          as="h4"
          color="medium"
          css={{
            marginLeft: theme.space[1],
            color: theme.colors.steel[1],
            fontSize: theme.fontSizes[1],
            marginTop: -2
          }}
        >
          {attackedHostsLastMonth}
        </Text>
      </div>
    </div>
  )
}

StatTile.propTypes = {
  attackedHosts: PropTypes.number,
  attackedHostsLastMonth: PropTypes.number
}

function UniqueTargetsAttacked() {
  const { attackedHosts, attackedHostsLastMonth, isLoading } =
    useCompanyReportData({ skipCompanyDetailsRequest: true })

  // TODO: uncomment once the data are available
  // const graphValues = useFormik({
  //   initialValues: {
  //     targetingStrategy: 'Exact',
  //     selectedTargets: [],
  //     targetParams: {}
  //   }
  // })

  if (isLoading) return <BusyOverlay rounded shown />

  return (
    <div
      css={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        alignItems: 'center',
        height: '100%',
        padding: theme.space[5],
        gap: theme.space[4]
      }}
    >
      <div>
        {/* Uncomment once the data are available */}
        {/* <InfraTargetsGraph
            orientation="left"
            targets={allClients}
            targetType="Hosts"
          /> */}
        <StatTile
          attackedHosts={attackedHosts}
          attackedHostsLastMonth={attackedHostsLastMonth}
        />
      </div>
    </div>
  )
}

export default function UniqueTargetsAttackedCard() {
  return (
    <CardWrapper
      hideFilter={true}
      renderCardContent={() => <UniqueTargetsAttacked />}
      title="Unique Targets"
    />
  )
}

UniqueTargetsAttackedCard.propTypes = {
  infraClients: PropTypes.object,
  alfiClients: PropTypes.object,
  isLoading: PropTypes.bool,
  completedAttacks: PropTypes.array,
  activeAttacks: PropTypes.array
}
